import { useCallback } from 'react'
import Table from 'components/table/Table'
import CreativeListItemBasic from 'features/creative/list/CreativeListItemBasic'
import CreativeListItemDetail from 'features/creative/list/CreativeListItemDetail'
import { useHistory, useParams } from 'react-router-dom'
import CreativeLibraryPropTypes from './CreativeLibraryPropTypes'
import { useSelector } from 'react-redux'

const CreativeListItem = ({
  creative,
  creative: { id, deleted, assetTypes },
}) => {
  const { openDetailIds } = useSelector(state => state.creative.creativeList)
  const history = useHistory()
  const { accountId } = useParams()
  const handleItemClick = useCallback(() => {
    if (!deleted) {
      history.push(`/${accountId}/creatives/${id}`)
    }
  }, [accountId, deleted, history, id])
  return (
    <>
      <Table.Row rowId={id} isDisabled={deleted}>
        <CreativeListItemBasic
          key={id}
          data={creative}
          onClickItem={handleItemClick}
        />
      </Table.Row>
      {openDetailIds.includes(id) && (
        <Table.Row rowId={`${id}_detail`} className="tr_depthitem" noCheckbox>
          <CreativeListItemDetail
            assetTypes={assetTypes}
            onClickItem={handleItemClick}
          />
        </Table.Row>
      )}
    </>
  )
}

export default CreativeListItem

CreativeListItem.propTypes = {
  creative: CreativeLibraryPropTypes.isRequired,
}
